import SliderView from './View';

export default (config) => {
  config.blocks.blocksConfig.slider.view = SliderView;

  return config;
};
